import jQuery from "jquery";

export function menuClasses(data, target) {
 console.log("menuClasses")

 console.log("data", data);
 console.log("target", target);

  // console.log("data.next.url.path", data.next.url.path);

  // plau we're passing in the desired classes etc - but only on  the current page
  // ie if this might not be targgeting rhe parents etc? - although currently okay with what;s here?


  $('nav.navigation').each(function () {
    //[data-barba-navigation="header"]
    //[data-barba-navigation="footer"]

    // console.log("data-barba-navigation");

    // console.log($(this).attr("data-barba-navigation"));

    $(this).find('.menu-item.' + target).each(function () {
      $(this).removeClass(target);
      // this should all the targets
    });

    $(this).find(`.menu-item > a[href$="${ data.next.url.path }"]`).closest('.menu-item').each(function () {
      $(this).addClass(target);
      // console.log("hello");


      if (target == "current_page_item") {
        // $(this).css("background", "red");

        $(this).parentsUntil($(".menu-header-menu-container"), 'li').addClass("sub-active");
        $(this).parentsUntil($(".menu-header-menu-container"), 'ul').addClass("sub-active");

        //    parents = $currentulmenu.parentsUntil($(".menu-header-menu-container"), "ul").length;

        // $(this).parents("li").addClass("sub-active");
        // $(this).parents("ul").addClass("sub-active");
        // console.log("current page item after adding subactive classes");
      }
      if (target == "current-post-ancestor") {
        // $(this).css("background", "red");
        // console.log("current-post-ancestor targeting");

        var url = data.next.url.path,
          // parts = url.split( '/'),
          // trimmedParts = parts.filter(Boolean),
          // totaltrimmedParts = trimmedParts.length,

          // https://stackoverflow.com/questions/16750524/remove-last-directory-in-url
          createtargeturl = url.substring(0, url.lastIndexOf('/')), // remove last '/'
          targeturl = createtargeturl.substring(0, createtargeturl.lastIndexOf('/')) + "/"; // // remove next url bit and add the '/' back in
        // console.log(" str " +  str + "");

        // what we want is to target the menu item that is a parent of the current post
        // which means that this function only run to apply on single post?

        // console.log("url =  " + url + "");
        // console.log("targeturl for post ancestor = " + targeturl + "");


      }

    });

    // if target is current page item - also asign the sub active links to the associated ul and li

  });

} //menuClasses(target)

// export function updateClasses() {

//   /* console.log("upateClasses function running");
//   console.log("touch" + touch + "value");
//   //  console.log("devGrid" + devGridOn + "value");

//   console.log("devGridOn_iso" + devGridOn_iso + "value");
//   console.log("devGridOn_rows" + devGridOn_rows + "value");
//   console.log("devGridOn_baselines" + devGridOn_baselines + "value");
//   console.log("devGridOn_vertlines" + devGridOn_vertlines + "value");
//   console.log("devGridOn_columns" + devGridOn_columns + "value");
//   */

//   if (devGridOn_iso == true) {

//     //  console.log("devGridOn_iso",devGridOn_iso);

//     var datatoggletype = "iso";
//     // console.log("devGridOn_iso == true");
//     $('body').addClass("grid__" + datatoggletype + "--active");
//     // console.log("devGridOn_iso", devGridOn_iso);


//   } else {
//     var datatoggletype = "iso";
//     $('body').removeClass("grid__" + datatoggletype + "--active");
//     // console.log("devGridOn_iso", devGridOn_iso);

//   }

//   if (devGridOn_rows == true) {
//     var datatoggletype = "rows";

//     // console.log("devGridOn_rows == true");
//     $('body').addClass("grid__" + datatoggletype + "--active");

//   } else {
//     var datatoggletype = "rows";
//     $('body').removeClass("grid__" + datatoggletype + "--active");

//   }

//   if (devGridOn_columns == true) {
//     var datatoggletype = "columns";
//     // console.log("devGridOn_columns == true");
//     $('body').addClass("grid__" + datatoggletype + "--active");

//   } else {
//     var datatoggletype = "columns";
//     $('body').removeClass("grid__" + datatoggletype + "--active");

//   }

//   if (devGridOn_baselines == true) {
//     var datatoggletype = "baselines";
//     // console.log("devGridOn_baselines == true");
//     $('body').addClass("grid__" + datatoggletype + "--active");

//   } else {
//     var datatoggletype = "baselines";
//     $('body').removeClass("grid__" + datatoggletype + "--active");

//   }
//   if (devGridOn_vertlines == true) {
//     var datatoggletype = "vertlines";
//     // console.log("devGridOn_vertlines == true");
//     $('body').addClass("grid__" + datatoggletype + "--active");

//   } else {
//     var datatoggletype = "vertlines";
//     $('body').removeClass("grid__" + datatoggletype + "--active");

//   }

//   console.log("touch", touch);
//   if (touch == true) {

//     // console.log("apply touch");
//     $('body').addClass('is-touch');
//     $("body").removeClass('is-not-touch');

//   } else {

//     // console.log("dont 'apply touch");

//     $("body").addClass('is-not-touch');
//     $("body").removeClass('is-touch');

//   } /// if minimisedradio

//   //re-apply current orientation class

//   if (orientationValue == "horizontal") {

//     $("body").addClass('is-horizontal');
//     // $("body").removeClass('is-vertical');
//     // console.log("is-horizontal");

//   } else {

//     /* vertical orientation */
//     // $("body").removeClass('is-horizontal');
//     // console.log("is-vertical");

//     $("body").addClass('is-vertical');

//   }
//   //after leaving

// } //function updateClasses()

export function updateClasses(touch, devGridOn_iso, devGridOn_rows, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines, orientationValue) {
  console.log("updateClasses function running");
  // console.log("updateClasses function running");

  // these variable are not being passed in - so they are not being updated?
  console.log("touch", touch);
  //  console.log("devGrid" + devGridOn + "value");

  // console.log("devGridOn_iso" + devGridOn_iso + "value");
  // console.log("devGridOn_rows" + devGridOn_rows + "value");
  // console.log("devGridOn_baselines" + devGridOn_baselines + "value");
  // console.log("devGridOn_vertlines" + devGridOn_vertlines + "value");
  // console.log("devGridOn_columns" + devGridOn_columns + "value");


  function toggleClass(condition, type) {

    console.log("toggleClass function running", condition, type);

    const className = `grid__${type}--active`;
    if (condition) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }

  toggleClass(devGridOn_iso, "iso");
  toggleClass(devGridOn_rows, "rows");
  toggleClass(devGridOn_columns, "columns");
  toggleClass(devGridOn_baselines, "baselines");
  toggleClass(devGridOn_vertlines, "vertlines");


  console.log("touch", touch);

  if (touch) {
    document.body.classList.add('is-touch');
    document.body.classList.remove('is-not-touch');
  } else {
    document.body.classList.add('is-not-touch');
    document.body.classList.remove('is-touch');
  }

  if (orientationValue === "horizontal") {
    document.body.classList.add('is-horizontal');
    document.body.classList.remove('is-vertical');
  } else {
    document.body.classList.add('is-vertical');
    document.body.classList.remove('is-horizontal');
  }


  console.log("updateClasses function leaving");

} // function updateClasses()



export function disableEnableDragging(flickityNav) {

 console.log("disableEnableDragging(flickity)", flickityNav);

  var select = flickityNav.select;

  flickityNav.select = function (index) {


 console.log("on select the flickity index = ", index);
    var activeTier = parseInt($('#menu-header-menu').attr("data-active-tier-index"));
 console.log("activeTier", activeTier);

    if (index <= activeTier) {
      //index needs to be less or equal than tier in order to allow sliding

     console.log("Allows sliding:", index, ":", activeTier);

    } else {
    console.log("Don't allows sliding", index, ":", activeTier);
      return;

    }
    select.apply(flickityNav, arguments);

  };

} //export function disableEnableDragging(flickity) 

export function removeUlSubActive() {
  // removes all active ul sub
  // console.log("removeUlSubActive");

  var $removeliitem = $('[data-barba-navigation="header"]').find('li.sub-active'), // the acitive link that contains the active ul
    $removeulmenu = $('[data-barba-navigation="header"]').find('ul.sub-active'); // the active ul

  if ($removeliitem.length) {
    // console.log("$liitem", $removeliitem);
    // $removeliitem.css("background", "red");
    $removeliitem.removeClass('sub-active');
  }
  if ($removeulmenu.length) {
    // console.log("$ulitem", $removeulmenu);
    // $removeulmenu.css("background", "green");
    $removeulmenu.removeClass('sub-active');
  }

  console.log("removeUlSubActive leaving");

}

export function scrollToTop() {
  console.log("scroll top function");

  // $('#main').animate({

  //   scrollTop: $("body").offset().top
  // }, 10);

  document.getElementById('main').scrollTo({
    top: document.body.offsetTop,
    behavior: 'smooth'
  });

  console.log("scroll top function done");
} //


// export function scrollToSection($container, hash) {

//   // console.log("scroll to Section", hash);

//   var itemid = hash.substring(1);
//   ////https://github.com/barbajs/barba/issues/53 -- infor re hahs


//   // console.log("itemid", itemid)
//   // console.log("scrolling now to ", hash)
//   // this doesn't work if you're coming from the about page
//   // anywhere else such as single services it always works and scroll to corret container
//   /*
//   Coul there be some scripts running from/on the about page that are causin issue with figuring out hte height of the document?
//   because of the animated logos or something?

//   */

//   setTimeout(function () {

//     // $container.find('#' + itemid + '').css("background","red");

//     // var offset = $container.find('#' + itemid + '').offset().top + 'px';
//     // console.log("ofset value",offset);
//     $('#main').animate({

//       scrollTop: $container.find('#' + itemid + '').offset().top + 'px'
//     }, 10);

//   }, 100); // timeout added here
//   // was 100 time out but still seems not to work - what do I need to wait for?
//   // this is realy fucking annoying - providing no 
// //jly 24' upadte to non jquery




// }

export function scrollToSection(container, hash) {
  var itemid = hash.substring(1);

  console.log("hash", itemid);
  console.log("container", container)

  setTimeout(function () {
    var targetElement = container.querySelector('#' + itemid);

    if (targetElement) {
      document.getElementById('main').scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  }, 100); // timeout added here
}


export function positionUls() {

  console.log("position ULS")

  $('.menu-header-menu-container li.menu-item-has-children').each(function () {
    // look for submenu item + determine the number of this
    var thisIndex = $(this).index(),
      $parent = $(this).find('ul').first(),
      number = Number(((thisIndex) * 2.5)) // 1.75 is the ration of a link height to the thisIndex
    // please not that this nuymber 1.75 also  define in he  assignNavHeightValues() function bveloew 
    // console.log("thisIndex", thisIndex)

    $parent.attr("data-link-parent-index", thisIndex);

    if (Number.isInteger(number)) {

      var returnNumber = number; // if just integer leave as is

    } else {

      var number = number.toFixed(2),
        returnNumber = number.replace(".", "_");
    };

    // console.log("returnNumber", returnNumber);
    $parent.addClass("--baseline-neg-top--" + returnNumber + ""); // current height of a link = 1.5 + addition lineheight space - review!

  });


  console.log(" end position ULS")

}

export function appendSlides() {
  // append the total number of slides needed based on ul depths
  var slideQuantities = 0

  //https://stackoverflow.com/questions/3555981/find-nesting-depth
  $('[data-barba-navigation="header"].navigation ul').each(function (i) {
    if (($(this).parents('ul').length + 1) > slideQuantities) {
      slideQuantities = $(this).parents('ul').length + 1;
      //need to remove one; as the first slide already there
      // slideQuantities = (slideQuantities - 1);// // maybe this +1 business is causeing the issue
    }
  });
  console.log('SlideQuantities', slideQuantities);

 console.log('SlideQuantities', slideQuantities);
  //append number or required slides
  for (var i = 1; i < slideQuantities; i++) {
    $('.navigation__slider').append('<div class="navigation__slider-item navigation__slider-item-' + (i + 1) + '"></div>');
  }

}

export function assignNavHeightValues() {

  // console.log("assignMenuHeightvalue");

  var menuHeight,
    totalMaxMenuItems,
    crumbHeight, // review
    crumbHeightRatio = 1.5, // review - smae as nav?
    navHeight,
    navItems,
    navItemsHeightRatio = 2.5, //was 3, // this based on the ratio of oul
    returnClassNumberMenu,
    returnClassNumberCrumb,
    returnClassNumberNav,
    $crumb = $('.crumb');


  //menu
  $('[data-barba-navigation="header"].navigation').each(function () {

    navItems = Math.max.apply(null, (

      $(this).find('.navigation__menu, .sub-menu', // review fi this work
        $(this)).map(function () {
        return $(this).children('li').length;
      })));

    menuHeight = Number(((navItems) * navItemsHeightRatio));

    // console.log(" navItemsHeightRatio", navItemsHeightRatio);
    // console.log("navItems total li ", navItems);

    if (Number.isInteger(menuHeight)) {

      returnClassNumberMenu = menuHeight; // if just integer leave as is

    } else {

      var newMenuHeight = menuHeight.toFixed(2);

      returnClassNumberMenu = newMenuHeight.replace(".", "_"); // replace with desired characters
    };

    // return returnNumber 

  });

  // crumb
  if ($crumb.length) {

    $crumb.each(function () {
      // crumbv obnly one line - so value equals 1
      crumbHeight = Number(((1) * crumbHeightRatio));
      if (Number.isInteger(crumbHeight)) {
        returnClassNumberCrumb = crumbHeight; // if just integer leave as is

      } else {

        var newCrumbHeight = crumbHeight.toFixed(2);
        returnClassNumberCrumb = newCrumbHeight.replace(".", "_"); // replace with desired characters
      };

    });

  } else {

    crumbHeight = 0;
    returnClassNumberCrumb = crumbHeight;
  }

  //total navigation height
  // - although crumb actuall out sie this selecotr - ther is only one navigtaion.
  $('[data-barba-navigation="header"].navigation').each(function () {

    navHeight = crumbHeight + menuHeight;
    // console.log("navHeight", navHeight);

    if (Number.isInteger(navHeight)) {

      returnClassNumberNav = navHeight; // if just integer leave as is
    } else {

      var newNavHeight = navHeight.toFixed(2);
      returnClassNumberNav = newNavHeight.replace(".", "_"); // replace with desired characters
    };

    // console.log("returnClassNumberNav", returnClassNumberNav);

  });

  //update total nav Height
  navHeight = crumbHeight + menuHeight;

  /*

  console.log("menuHeight", menuHeight);
  console.log("crumbHeight", crumbHeight);
  console.log("navHeight", navHeight);

  console.log("returnClassNumberMenu", returnClassNumberMenu);
  console.log("returnClassNumberCrumb", returnClassNumberCrumb);
  console.log("returnClassNumberNav", returnClassNumberNav);
  */
  //.setting heighrts of the submenu items - only needs to tbe done once - sor consider moving out here
  $('[data-barba-navigation="header"] .sub-menu').addClass("--baseline-height--" + returnClassNumberMenu + "");
  $('[data-barba-navigation="header"] .navigation__slider-item').addClass("--baseline-height--" + returnClassNumberMenu + "");
  $('[data-barba-navigation="header"] .navigation__slider').addClass("--baseline-height--" + returnClassNumberMenu + ""); // current height of a link = 1.5 + addition lineheight space
  $('.footer__nav-filler').addClass("--baseline-height--" + returnClassNumberMenu + ""); // current height of a link = 1.5 + addition lineheight space
  $('.sticky-class__target').addClass("--baseline-top--" + returnClassNumberCrumb + "");

}

export function slideToSlide(flickityNav, tiernumber) {

  console.log("slide to slide - tiernumber", tiernumber);
  console.log("slide to slide - tiernumber", flickityNav);

  // disableSlides(flickity, tiernumber);
  if (tiernumber == 0) { // we should only be able to drag if the tier number is more than 1
    //disbale draggin on the first slide
    // flickityNav.unbindDrag(); // no drag on start - but that should only be on the first tier
    // var tiernumber = parents;
  } else {
    // flickityNav.bindDrag(); // no drag on start - but that should only be on the first tier
    console.log("bind dragging"); //remvint this unbiding shit for now - review

  }

  console.log("flickityNav - select tiernumber", tiernumber);

  flickityNav.select(tiernumber, false, false);
  // now that we are on teh next slide - determine the enabling and disabling of dragging on given index
  disableEnableDragging(flickityNav);
  //maybe reveiew


} //export function slideToSlide(tiernumber) 

export function initialMenuState(flickityNav) {

  console.log("set inital menu state", flickityNav);
  console.log("OR after Barba change", flickityNav); // that mean we nee dto sure the varibale updates

  var $currentaitem = $('[data-barba-navigation="header"]').find(' li.current-menu-item a').first(), //make sure it only selects the first available llink - as there moight be more than in in teh me ndu  
    $currentliitem = $currentaitem.parent("li"),
    $currentulmenu = $currentliitem.parent("ul"), // the current one tha tthe active link resides in
    $parentliitem = $currentulmenu.parent("li"), // the imeddiate submenu that is active 
    $currentmenuancestors = $('li.current-menu-ancestor'), // ancesoros li 
    $currentmenuancestorsul = $('li.current-menu-ancestor > ul'), //  ancesoros li's immmediate ul
    parents = $currentulmenu.parentsUntil($(".menu-header-menu-container"), "ul").length;

  if (parents == 0) {
    var tiernumber = parents;
  } else {
    var tiernumber = (parents + 0); // was (parents + 1); 
  }
  // maybe if if we determien its the fist item return anothe number

  $currentulmenu.addClass('sub-active');
  $parentliitem.addClass('sub-active');
  $currentmenuancestors.addClass('sub-active'); //more than one potentially
  $currentmenuancestorsul.addClass('sub-active');

  // $('li.current-menu-item a').css("background", "red");

  /*
  $currentaitem.css("background", "gold");

  $currentliitem.css("background", "pink");
  $currentulmenu.css("background", "brown");
  $parentliitem.css("background", "green");
  $currentmenuancestors.css("background", "blue");
  $currentmenuancestorsul.css("background", "grey");
  */
  // console.log("  $currentulmenu",   $currentulmenu);

  // console.log("parents", parents);
  // console.log("tiernumber insite initialmenustate", tiernumber);

  // disableSlides(flickity, tiernumber);

  console.log("looking to go tiernumber", tiernumber);
  slideToSlide(flickityNav, tiernumber);

}

// export function offsetClickIndex($navigation__menu) {

//   // console.log("offsetClickIndex");


//   // offsetClickIndex = 0 for SM - 0cols
//   // offsetClickIndex = 1 for MD - 2cols
//   // offsetClickIndex = 2 for LG - 3cols
//   // console.log("$( window ).width() =")
//   console.log($(window).width());

//   var $width = $(window).width();


//   if ($width < 456) { // 

//    console.log("1 column");

//     // 1 nav col
//     var setoffsetClickIndex = 0;
//     $navigation__menu.attr("data-offset-click-index", setoffsetClickIndex); // set itial at mobile - then change on breakpoints

//   } else if ($width < 1176) {
//     console.log("2 column");

//     // 2 nav col
//     var setoffsetClickIndex = 1;
//     $navigation__menu.attr("data-offset-click-index", setoffsetClickIndex); // set itial at mobile - then change on breakpoints

//   } else {
//     console.log("3 column");
//     // 3 nav col
//     var setoffsetClickIndex = 2;
//     $navigation__menu.attr("data-offset-click-index", setoffsetClickIndex); // set itial at mobile - then change on breakpoints

//   }

// }
export function offsetClickIndex(navigationMenu) {

  // Log the window width
  console.log(window.innerWidth);

  // Get the window width
  var width = window.innerWidth;

  // // Get the navigation menu element
  // var navigationMenu = document.querySelector('.navigation__menu');

  // Check the window width and set the data-offset-click-index attribute accordingly
  if (width < 456) {
    console.log("1 column");
    navigationMenu.setAttribute("data-offset-click-index", "0"); // Set initial at mobile - then change on breakpoints
  } else if (width < 1176) {
    console.log("2 column");
    navigationMenu.setAttribute("data-offset-click-index", "1"); // Set initial at mobile - then change on breakpoints
  } else {
    console.log("3 column");
    navigationMenu.setAttribute("data-offset-click-index", "2"); // Set initial at mobile - then change on breakpoints
  }

}

export function crumbObserver(nextcontainer) { //barna container
  console.log("crumb ovbserverget")

  // console.log (crumbObserver(nextcontainer));
  // let target = nextcontainer.querySelector('h1'); // this is bad! - we need to target the first objecton thepage and not an element that is likely used multiple times if any
  let target = nextcontainer.querySelector('article'); // this is bad! - we need to target the first objecton thepage and not an element that is likely used multiple times if any
  console.log("target", target);

  if (!target) {
    // let target = nextcontainer.querySelector('h1');

    console.log("no observer target _ SVS RESOLVE!!!!");
  }

  if (target) {

    // console.log("we have a target - do we have a crumb?");

    let crumb = nextcontainer.querySelector('#crumb-header'),
      root = document.querySelector('#main');

    if (crumb) { // no crumb on homepag

      const intersectionCallback = (entries) => {
        entries.forEach((entry) => {
          /* if (entry.isIntersecting) {

               // openanimation(type);
                 //  console.log("entry.isIntersecting");
               // crumb.classList.add("--is-active");
               return;
               //  console.log("LOGO Element is intersecting with the container ");
           }*/

          if (entry.boundingClientRect.top > 0) {
            // console.log("BELOW") // do things if below
            // crumb.classList.add("--is-active");
            crumb.classList.remove("--visible");
          } else {
            // console.log("ABOVE") // do things if above
            crumb.classList.add("--visible");
          }
        });

      };

      //https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      const intersectionObserverCrumb = new IntersectionObserver(intersectionCallback, {
        root: root,
        rootMargin: "0px 0px -100%", // "0px 0px 1000px 0px"//"0px 0px 0% 0px"
        // root: container, // Leave this `root` out if you would like to use the device's viewport
        threshold: 0
      });

      intersectionObserverCrumb.observe(target);

    }

  }

} //function crumbObserver()

export function closeNavigation($nextcontainer) {
  // no need to pass in var/ new container?

  // console.log("hello closeNavigation");

  var $navigation__toggle = $('body').find('.navigation__toggle');

  if ($('body').hasClass('toggled-on')) {
    $navigation__toggle.click(); // this will trigger thealready setup click function

  }
}